import { BrowserRouter as Router, Route, Link, Routes } from 'react-router-dom';

function PrivacyPolicyLink() {

 return (
    <Router>
      <div>
        <nav>
          <Link to="/privacy-policy">개인정보처리방침</Link>
        </nav>
        <Routes>
          <Route path="/privacy-policy" element={<iframe src="/privacy-policy.html" style={{width: '100%', height: '100vh'}} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default PrivacyPolicyLink;

